// extracted by mini-css-extract-plugin
export var infoItem = "_kf-1";
export var title = "_kf-0";